import React from 'react';
import { Route, Switch } from 'react-router';
import { RestrictedRoute } from '../utils/RestrictedRoute';
import WheelLocationsTable from '../components/WorkshopPlanning/General/WheelLocations/WheelLocationsTable';
import WheelLocationCreation from '../components/WorkshopPlanning/General/WheelLocations/WheelLocationCreation';
import { Permissions } from '../utils/Permissions';

export default function WheelLocationsRouting(props) {
  const { currentIdentity, resources } = props;

  return (
    <>
      <RestrictedRoute path='/wheellocations' userPermissions={currentIdentity.permissions} routePermissions={[Permissions.WorkshopSettings]} resources={resources} render={(props) => {
        return (<WheelLocationsTable resources={resources} refreshGrid={props && props.location && props.location.state && props.location.state.refreshGrid} accessibleMoboOutlets={currentIdentity.accessibleMoboOutlets} outletId={props?.location?.state?.outletId ?? 0} />)
      }} />
      <Switch>
        <Route exact path='/wheellocations/new' render={(props) => (<WheelLocationCreation resources={resources}  wheelLocationId={props.match.params.wheelLocationId}  accessibleMoboOutlets={currentIdentity.accessibleMoboOutlets} language={currentIdentity.culture.substring(0,2)} redirectToOutletPage={props?.location?.state?.redirectToOutletPage ?? false} />)} />
        <Route exact path='/wheellocations/:wheelLocationId' render={(props) => {
          return (<WheelLocationCreation resources={resources} wheelLocationId={props.match.params.wheelLocationId} editedWheelLocation={props.match.params.editedWheelLocation} accessibleMoboOutlets={currentIdentity.accessibleMoboOutlets}  language={currentIdentity.culture.substring(0,2)} redirectToOutletPage={props?.location?.state?.redirectToOutletPage ?? false} />)
        }} />
      </Switch>
    </>
  )
}